"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
export default function OurVenuePartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222480" id="partnering-with-excellence" className="text-foreground overflow-hidden border-y border-border/10 py-20 dark rounded-xl !border-4 border-solid border-[oklab(0.915745-0.0031950.091728/0.1)] md:py-32 bg-background bg-center bg-[length:1000px] !bg-[url(https://golden-serval.10web.cloud/wp-content/uploads/2026/05/8928FCE6-4650-481F-88B9-2A817E6A3C50-1-e1779893566628.png)]">
      <div ref={ref} className={`container mx-auto px-4 transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        <div className="flex flex-col md:flex-row gap-8 lg:gap-12 items-stretch justify-center max-w-6xl mx-auto">
          
          {}
          <Card className="flex-1 bg-background/50 border-primary/20 flex flex-col justify-between p-6 md:p-8 relative overflow-hidden">
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-10 blur-xl z-0">
              <WvcLogo className="h-64 w-auto" />
            </div>
            <div className="relative z-10 flex flex-col h-full">
              <CardHeader className="p-0 mb-6">
                <CardTitle className="font-semibold font-serif text-primary mb-4 !text-[35px]">Contact Us for Artists</CardTitle>
                <CardDescription className="text-muted-foreground text-lg leading-relaxed">
                  Discover the exceptional talent that will elevate your event. From international musicians to elite acrobats, we connect your stage with the brightest stars in the world.
                </CardDescription>
              </CardHeader>
              <CardContent className="p-0 mt-auto">
                <Button asChild className="w-full md:w-auto bg-primary text-primary-foreground hover:scale-105 transition-transform duration-300 px-8 py-6 text-lg font-medium">
                  <Link to="/SecureYourTalentPage">
                    Request Artists
                  </Link>
                </Button>
              </CardContent>
            </div>
          </Card>

          {}
          <Card className="flex-1 bg-background/50 border-primary/20 flex flex-col justify-between p-6 md:p-8 relative overflow-hidden">
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-10 blur-xl z-0">
              <WvcLogo className="h-64 w-auto" />
            </div>
            <div className="relative z-10 flex flex-col h-full">
              <CardHeader className="p-0 mb-6">
                <CardTitle className="font-semibold font-serif text-primary mb-4 !text-[35px]">Disfruta tu Viaje Perfecto</CardTitle>
                <CardDescription className="text-muted-foreground text-lg leading-relaxed">Diseñamos experiencias de viaje exclusivas. Logística impecable and confort de lujo para que su única prioridad sea disfrutar de sus viajes. ¡Su viaje, nuestra pasión!</CardDescription>
              </CardHeader>
              <CardContent className="p-0 mt-auto">
                <Button asChild className="w-full md:w-auto bg-primary text-primary-foreground hover:scale-105 transition-transform duration-300 px-8 py-6 text-lg font-medium">
                  <Link to="/PerfectTripPage">Promociones Viajes</Link>
                </Button>
              </CardContent>
            </div>
          </Card>

        </div>
      </div>
    </section>;
}